import React, { useState, useEffect } from 'react';
import HomeScreen from './HomeScreen';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PdfViewer from './About/PdfViewer'; // import the PDF viewer component
import Program from './Program/Program';
import './App.css';
import AboutCon from './About/AboutCon';
import LoadReg from './Loader/LoadReg';
import Professional from './Registration/Professional';
import Confirmation from './Registration/Confirmation';
import PageNotFound from './404_page/PageNotFound';
import Demographics from './Demographics/Demographics';
import Youthevent from './Youth_Event/Youthevent';
import Venue from './Venue/Venue';
import View from './Video/View';
import Gallery from './Gal/Gallery';
import  Speaker  from './Speakers/Speaker';

function App() {
  const [data, setData] = useState(null);

  //Function To loose opacity/clarity after one year
  const [opacity, setOpacity] = useState(1);


  //useEffect   To loose opacity/clarity after one year
  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch('/api/data');
      const json = await response.json();
      setData(json);
    };

    fetchData();

    const fadeTimeout = setTimeout(() => {
      setOpacity(0);
    }, 31536000000); // 1 year in milliseconds

    return () => {
      clearTimeout(fadeTimeout);
    };
  }, []);
//....................................................................................................................





  return (

    //div class To loose opacity/clarity after one year
    <div className="App" style={{ opacity, transition: 'opacity 2s' }}>
{/*....................................................................................................*/}
      <Router>
        <Routes>
          <Route exact path="/" element={<HomeScreen />} />
          <Route path="/pdf" element={<PdfViewer />} /> 
          <Route path="/program" element={<Program />} />
          <Route path="/about_kippra" element={<AboutCon />} />
          <Route path="/profile" element={<LoadReg />} />
          <Route path="/professional" element={<Professional />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/conference" element={<AboutCon />} />
          <Route path="/demographics" element={<Demographics />} />
          <Route path="/youth_event" element={<Youthevent />} />
          <Route path='/venue' element={<Venue />} />
          <Route path='/vid' element={<View />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path= '/speakers' element={<Speaker />} />
          <Route path='/404' element={<PageNotFound />} />
          <Route path="*" element={<PageNotFound />} />
        
        </Routes>
      </Router>
      {data && <p>{data.message}</p>}
    </div>
  );
}

export default App;
